// components/SyncSelectedCompany.tsx
import { useEffect, useRef } from 'react';
import { useCompaniesStore } from '../../store/companies/useCompaniesStore';
import { useEmpruntsStore } from '../../store/emprunt/useEmpruntsStore';
import { useTransactionsStore } from '../../store/transactions/useTransactionsStore';
import { useBalanceStore } from '../../store/balance/useBalanceStore';
import { FilterType } from '../../components/Transactions/FiltersDivers/TagRendering/TagMapping';
import { FilterBalanceType } from '../../components/Balance/FilterType';
import { useExercicesStore } from 'src/store/exercices/useExercicesStore';
import { useFinconnectStore } from 'src/store/finconnect/useFinconnectStore';

export const SyncSelectedCompany = () => {
  const previousCompanyId = useRef<string | null>(null);

  useEffect(() => {
    // S'abonne à tous les changements du store
    const unsubscribe = useCompaniesStore.subscribe((state) => {
      const currentId = state.selectedCompany?.id ?? null;

      // Vérifie si la société a changé
      if (currentId !== previousCompanyId.current) {
        previousCompanyId.current = currentId;

        // Réinitialise l'emprunt sélectionné
        useEmpruntsStore.getState().setSelectedEmprunt(null);
        // Réinitialise l'onglet actif
        useEmpruntsStore.getState().setActiveTabKey('1');
        // Réinitialise les valeurs sélectionnées dans les transactions
        useTransactionsStore.getState().setSelectedValues([]);
        // Réinitialise les exercices actifs
        useExercicesStore.getState().setActiveExercices([]);
        useFinconnectStore.getState().reset();

        useTransactionsStore.getState().setSavedFilters((prev: Map<FilterType, any>) => {
          const filterJournalMap = new Map(prev);
          const analyticDefaultValue =
            state.selectedCompany?.analyticParameters!.analyticViewDefault;
          if (analyticDefaultValue != undefined && analyticDefaultValue) {
            filterJournalMap.set(FilterType.COMPTABILITE_ANALYTIQUE_JOURNAL, true);
            filterJournalMap.set(FilterType.COMPTABILITE_ANALYTIQUE_GRAND_LIVRE, true);
            filterJournalMap.set(FilterType.COMPTABILITE_STANDARD_JOURNAL, false);
            filterJournalMap.set(FilterType.COMPTABILITE_STANDARD_GRAND_LIVRE, false);
          } else {
            filterJournalMap.set(FilterType.COMPTABILITE_STANDARD_JOURNAL, true);
            filterJournalMap.set(FilterType.COMPTABILITE_STANDARD_GRAND_LIVRE, true);
            filterJournalMap.set(FilterType.COMPTABILITE_ANALYTIQUE_JOURNAL, false);
            filterJournalMap.set(FilterType.COMPTABILITE_ANALYTIQUE_GRAND_LIVRE, false);
          }
          return filterJournalMap;
        });

        useBalanceStore.getState().setSavedFilters((prev) => {
          const filterBalanceMap = new Map(prev);
          const analyticDefaultValue =
            state.selectedCompany?.analyticParameters!.analyticViewDefault;
          if (analyticDefaultValue != undefined && analyticDefaultValue) {
            filterBalanceMap.set(FilterBalanceType.COMPTABILITE_ANALYTIQUE, true);
            filterBalanceMap.set(FilterBalanceType.COMPTABILITE_STANDARD, false);
          } else {
            filterBalanceMap.set(FilterBalanceType.COMPTABILITE_ANALYTIQUE, false);
            filterBalanceMap.set(FilterBalanceType.COMPTABILITE_STANDARD, true);
          }
          return filterBalanceMap;
        });
      }
    });

    return () => unsubscribe(); // Nettoyage à la fin
  }, []);

  return null;
};
